import React from "react";
import { Button, Dialog, TextField, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import logo from "./assets/saiVaniLogo.png";

import firebase from "firebase";

import FingerprintJS from '@fingerprintjs/fingerprintjs'

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load({
  monitoring: false
})

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      openForgotPasswordDialog: false,
      emailWrong: false,
      pwdWrong: false,
      forgotEmailWrong: false,
      forgotEmail: '',
      userName: '',
      pwd: ''
    };
  }

  handleOpenOrCloseForgotPasswordDialog = () => {
    this.setState({
      openForgotPasswordDialog: !this.state.openForgotPasswordDialog
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    
    const db = firebase.firestore();
    let deviceFingerPrint;
    fpPromise
      .then(fp => fp.get())
      .then(result => {
        deviceFingerPrint = result.visitorId
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(_ => {
            const { userName, pwd } = this.state

            return firebase
              .auth()
              .signInWithEmailAndPassword(userName.toString().trim(), pwd.toString().trim())
              .catch((err) => {
                if (err["code"] === "auth/wrong-password") {
                  this.setState({
                    pwdWrong: true,
                    emailWrong: false,
                  });
                } else if (err["code"] === "auth/invalid-email") {
                  this.setState({
                    emailWrong: true
                  });
                } else if (err["code"] === "auth/user-not-found") {
                  this.setState({
                    pwdWrong: false,
                    emailWrong: true,
                  });
                }
              });
          })
          .catch(err => {
            console.error(err);
          })
      })
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      forgotEmailWrong: false,
      emailWrong: false,
      pwdWrong: false
    });
  };

  handleForgotPasswordChangeForm = (e) => {
    e.preventDefault();

    const { forgotEmail } = this.state
    
    firebase.auth().sendPasswordResetEmail(forgotEmail)
      .then((user) => {
        alert("Password reset email sent!")
        window.location.reload()
      })
      .catch((error) => {
        this.setState({
          forgotEmailWrong: true
        })
      });
  }

  render() {
    const { userName, pwd, pwdWrong, emailWrong, forgotEmail, forgotEmailWrong } = this.state;
    return (
      <div style={{ display: "flex" }}>
        <form
          key="saiVaniAppLoginForm"
          onSubmit={(e)=> this.handleSubmit(e)}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            key="saiVaniAppLogo"
            src={logo}
            style={{ width: 220, height: 90 }}
          />
          {/* <h2 style={{ fontWeight: 500, display: 'flex', justifyContent: 'center' }} >
            Welcome.
          </h2> */}
          <TextField
            key="saiVaniAppUserNameTextField"
            type="text"
            size="medium"
            style={{ margin: "10px 0px", marginTop: 20, width: 300 }}
            variant="outlined"
            name="userName"
            value={userName}
            required
            onChange={this.handleChange}
            color={emailWrong ? "secondary" : "primary"}
            label={"Email"}
            error={emailWrong}
            helperText={emailWrong && "Incorrect email"}
          />
          <TextField
            type="password"
            size="medium"
            key="saiVaniAppUserNamePwdField"
            label="Password"
            style={{ margin: "10px 0px", width: 300 }}
            variant="outlined"
            required
            name="pwd"
            value={pwd}
            onChange={this.handleChange}
            color={pwdWrong ? "secondary" : "primary"}
            error={pwdWrong}
            helperText={pwdWrong && "Wrong password"}
          />
          <Button
            key="saiVaniAppFormSubmitButton"
            style={{ width: 300, marginTop: 15 }}
            type="submit"
            variant="contained"
            color="primary"
          >
            Log in
          </Button>

          <Button
            key="forgetPasswordButton"
            style={{ width: 300, marginTop: 15 }}
            variant="outlined"
            onClick={this.handleOpenOrCloseForgotPasswordDialog}
          >
            Forgot password ?
          </Button>
        </form>
        <div style={{ flex: 3 }} />
        <Dialog open={this.state.openForgotPasswordDialog} fullWidth >
          <DialogTitle>
            Form to get reset link, to change your password
          </DialogTitle>
          <form onSubmit={this.handleForgotPasswordChangeForm} >
            <DialogContent>
              <TextField
                key="saiVaniAppUserEmailToSendResetLink"
                type="text"
                size="medium"
                style={{ width: "100%" }}
                variant="outlined"
                name="forgotEmail"
                value={forgotEmail}
                required
                onChange={this.handleChange}
                color={forgotEmailWrong ? "secondary" : "primary"}
                label={"Email"}
                error={forgotEmailWrong}
                helperText={forgotEmailWrong && "Incorrect email"}
              />
              <Button
                key="saiVaniAppFormSubmitButton"
                style={{ width: "100%", marginTop: 15, marginBottom: 20 }}
                type="submit"
                variant="outlined"
                color="primary"
              >
                Submit
              </Button>
            </DialogContent>
          </form>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(Login);
